import {RentContract} from "../../../models/RentContract";

export function sumAllPastRevenue(contracts: RentContract[]): string {
    let total = 0;
    const now = new Date();

    for (const contract of contracts) {
        const start = new Date(contract.startDate);
        const end = new Date(contract.endDate);

        // Only count up to "now"
        const effectiveEnd = end < now ? end : now;

        // If the effectiveEnd is before start, no months in the past
        if (effectiveEnd < start) {
            continue;
        }

        const months = countMonthsInclusive(start, effectiveEnd);
        total += months * contract.monthlyPrice;
    }

    const result = Math.round(total * 100) / 100;

    return formatRevenue(result);
}

function countMonthsInclusive(start: Date, end: Date): number {
    const startYear = start.getFullYear();
    const startMonth = start.getMonth(); // 0-based
    const endYear = end.getFullYear();
    const endMonth = end.getMonth();

    const startTotal = startYear * 12 + startMonth;
    const endTotal = endYear * 12 + endMonth;

    return endTotal - startTotal + 1;
}

function formatRevenue(revenue: number): string {
    return revenue.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}